module.exports = __webpack_public_path__ + "img/377.e7ed8aeb.jpg";